export * from './testing/e2e_util';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
